/*  UI  */
import { Box, Form, FormInput } from '@auviknetworks/iceberg-ui';

/*  Packages  */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDashboardContext } from '../DashboardContext';

interface SearchProps {
    /** The function to call when the search input changes. */
    onChange: React.Dispatch<React.SetStateAction<string>>;
}

/**
 * Search input for the dashboard.
 */
export const Search = ({ onChange }: SearchProps) => {
    const { t } = useTranslation();
    const {
        dashboardState: { isEditing }
    } = useDashboardContext();

    return (
        <Box maxWidth="512px" width="100%">
            <Form onSubmit={() => {}}>
                <FormInput
                    disabled={isEditing}
                    inputType="search"
                    name="search"
                    registerProps={{
                        onChange: (e) => onChange(e.target.value)
                    }}
                    placeholder={t('Dashboard.search')}
                />
            </Form>
        </Box>
    );
};
